export const serverUrl = "https://api.cg.educationglobal.live";
// export const serverUrl = "https://api.educationglobal.tech";
// export const serverUrl = "http://127.0.0.1:5000";
